goog.provide("shadow.js.shim.module$src$svg$artwork$hourglass_svg$default");
shadow.js.shim.module$src$svg$artwork$hourglass_svg$default = shadow.js.shim.module$src$svg$artwork$hourglass_svg.default;
